
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/migration/v5-style-changes",
      function () {
        return require("private-next-pages/material-ui/migration/v5-style-changes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/migration/v5-style-changes"])
      });
    }
  